export default "__VITE_ASSET__amuZHtzF__"